/**
 * 결제 취소 모달
 * FSD: features/subscription/payment-history/ui
 */

import React, { useState } from 'react';
import type { PaymentTransaction } from '@/entities/payment/model';
import { usePaymentCancel } from '../hooks/use-payment-cancel';
import { formatAmount } from '@/shared/lib/payment/format-amount';

interface CancelModalProps {
  transaction: PaymentTransaction;
  onClose: () => void;
  onSuccess?: () => void;
}

export const CancelModal: React.FC<CancelModalProps> = ({ transaction, onClose, onSuccess }) => {
  const [reason, setReason] = useState('');
  const { mutate, isPending } = usePaymentCancel();

  const handleCancel = async () => {
    if (!reason.trim()) {
      alert('취소 사유를 입력해주세요');
      return;
    }

    mutate(
      {
        tid: transaction.tid,
        amount: transaction.amount.toString(),
        reason,
      },
      {
        onSuccess: () => {
          alert('결제가 취소되었습니다');
          onSuccess?.();
          onClose();
        },
        onError: (error: any) => {
          alert(`취소 실패: ${error.message}`);
        },
      }
    );
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h2>결제 취소</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>

        <div className="modal-body">
          <div className="info-row">
            <span className="label">상품명</span>
            <span className="value">{transaction.goods_name}</span>
          </div>

          <div className="info-row">
            <span className="label">취소 금액</span>
            <span className="value">{formatAmount(transaction.amount)}</span>
          </div>

          <div className="form-group">
            <label htmlFor="reason">취소 사유</label>
            <textarea
              id="reason"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="취소 사유를 입력해주세요"
              rows={4}
              disabled={isPending}
            />
          </div>
        </div>

        <div className="modal-footer">
          <button
            onClick={handleCancel}
            disabled={isPending || !reason.trim()}
            className="confirm-button"
          >
            {isPending ? '처리 중...' : '취소'}
          </button>
          <button onClick={onClose} disabled={isPending} className="cancel-button">
            닫기
          </button>
        </div>
      </div>
    </div>
  );
};
